module.exports = __webpack_public_path__ + "static/media/user-profile.77595d50.jpeg";